import { phoneMasks } from '@/core/consts/masks';

export const isValidEmail = (string: string) =>
  /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(
    string,
  );

export const clearPhoneFormat = (string: string) => string.replace(/[^0-9]/g, '');

export function formatPhoneNumber(phone: string) {
  const masksValues = Object.values(phoneMasks);

  const mask = masksValues.find((mask) => phone.startsWith(mask.replace(/\D/g, '')));

  if (!mask) {
    return;
  }

  const maskDigits = mask.replace(/\D/g, '');
  const phoneDigits = phone.replace(/\D/g, '').replace(maskDigits, '');
  let formattedNumber = '';
  let digitIndex = 0;

  for (let i = 0; i < mask.length; i++) {
    if (mask[i] === '#') {
      if (digitIndex < phoneDigits.length) {
        formattedNumber += phoneDigits[digitIndex];
        digitIndex++;
      } else {
        break;
      }
    } else {
      formattedNumber += mask[i];
    }
  }

  return formattedNumber;
}

export const declensionString = (number: number, titles: string[]) => {
  const cases = [2, 0, 1, 1, 1, 2];
  return `${titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]]}`;
};

export const containsSubstring = (s1: string, s2: string) => s1.toLowerCase().includes(s2.toLowerCase());

export const replaceStringAt = (string: string, index: number, replacement: string) =>
  string.substring(0, index) + replacement + string.substring(index + replacement.length);
